<template>
  <main>
    <div class="navbar-fixed">
      <nav :style="'backgroundColor:'+backgroundColor+';'">
        <div class="nav-wrapper center-align">
          <img class="logo-navbar " :src='image'/>
        </div>
      </nav>
    </div>
    <div class="row">
      <div class="col s10 m8 l6 offset-s1 offset-m2 offset-l3">
        <div class="card-panel center-align">
          <span class="titulo-card">
            Sesión inválida.
            <br>
            Vualve a iniciar sesión
          </span>
          <br>
          <br>
          <button type="submit" class="waves-effect waves-light btn boton-personalizado" @click="siguiente"
                  :style="{'background-color': accentColor}">Iniciar sesión
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {getEmpresa, setTheme} from "@/api/api";
import {mapState} from "vuex";

let gEmpresa = ''
let intento = 1
export default {
  name: "SesionInvalida",
  data(){
    return{
      empresa:"",
    }
  },
  methods:{
    siguiente(){
      this.$router.push({path: `/${this.empresa}`})
    }
  },
  mounted() {
    this.empresa = this.$route.params.empresa
    const dominio = window.location.href

    if (dominio.includes('recargastgmex.mx')) this.empresa = 'tgmex'
    if (dominio.includes('recargaszaz.com.mx')) this.dominioI = 'zaz'
    if (this.imagenFondo.length > 1) this.gettedVideo = true
    setTimeout(() => {
      M.updateTextFields()
    }, 150)
  },
  beforeCreate() {
    let auxEmpresa = this.$route.params.empresa
    this.empresa=this.$route.params.empresa
    if (auxEmpresa === 'login') {
      const dominio = window.location.href
      if (dominio.includes('herramientasbaevi.com')) auxEmpresa = 'baevi'
      else if (dominio.includes('gmcel.com')) auxEmpresa = 'gmcel'
      else if (dominio.includes('gruposima.mx')) auxEmpresa = 'gruposima'
      else if (dominio.includes('enlaceshop.com')) auxEmpresa = 'enlaceshop'
      else if (dominio.includes('recargasgsmoviles.com.mx')) auxEmpresa = 'gsmoviles'
      else if (dominio.includes('recargastgmex.mx')) auxEmpresa = 'tgmex'
      else if (dominio.includes('recargasasec.com')) auxEmpresa = 'asec'
      else if (dominio.includes('recargasdraggomovil.com')) auxEmpresa = 'draggomovil'
      else if (dominio.includes('leiphone.com.mx')) auxEmpresa = 'leiphone'
      else if (dominio.includes('damtel')) auxEmpresa = 'damtel'
      else if (dominio.includes('recargaszaz.com.mx'))  auxEmpresa = 'leiphone'
      else if (dominio.includes('cmtex.com.mx'))  auxEmpresa = 'cmtex'
      else if (dominio.includes('activasimrecargas.com'))  auxEmpresa = 'activasim'
      else if (dominio.includes('simcroft'))  auxEmpresa = 'simcroft'
      else if (dominio.includes('innova'))  auxEmpresa = 'innova'
      else if (dominio.includes('discovery'))  auxEmpresa = 'discovery'
      else if (dominio.includes('devsol'))  auxEmpresa = 'devsol'
      else if (dominio.includes('tridial'))  auxEmpresa = 'tridial'
      else if (dominio.includes('movicell'))  auxEmpresa = 'movicell'
      else if (dominio.includes('todosim'))  auxEmpresa = 'todosim'
      else if (dominio.includes('eradigital'))  auxEmpresa = 'eradigital'
      else if (dominio.includes('silverphone'))  auxEmpresa = 'silverphone'
      else if (dominio.includes('celstar'))  auxEmpresa = 'celstar'
      else if (dominio.includes('vam'))  auxEmpresa = 'vam'
      else if (dominio.includes('aba'))  auxEmpresa = 'damtel'


    }
    this.empresa=auxEmpresa
    console.log(auxEmpresa)
    gEmpresa = auxEmpresa
    console.log(`antes del mntenioajanh`, intento)
    if(intento === 1){
      console.log(`entyro al imntentomjnwqk `, intento)
      getEmpresa(gEmpresa).then(response => {
        localStorage.setItem('empresa', gEmpresa)
        console.log(`hizo la peti`, intento)
        console.log(response.empresa)
        console.log('recargas:', response.empresa.recargaSinUsuario)
        this.$store.commit('theming', response.empresa)
        setTimeout(() => {
          this.gettedVideo = response.empresa.imagenFondo !== ''
        }, 10)
        const empresa = response.empresa
        setTheme(document, empresa.primaryColor, empresa.darkenColor, empresa.accentColor)
      }).catch(error => {
        console.log(error)
        intento = 2
        console.log(`error ene elro `, intento)
        M.toast({html: error.message, classes: 'rounded', displayLength: 10000})
        this.$router.push({name: 'sinEmpresa'})
      })
    }

  },
  computed: {
    ...mapState(['primaryColor', 'accentColor', 'accentColor', 'backgroundColor', 'image', 'imagenFondo', 'izquierdoLogin', 'hideNav'])
  }
}
</script>

<style scoped>
.navbar-fixed {
  margin-top: -5px;
}

nav {
  background-color: white !important;
}

.logo-navbar {
  max-height: 80%;
  margin-top: 10px;
}


.titulo-card {
  font-size: 2.3em;
  position: relative;
  font-family: "Roboto Light", sans-serif;
}

.card-panel{
  margin-top: 50px;
}

.boton-personalizado {
  min-width: 79%;
  margin-top: 15px;
  font-size: 1.2em;
  height: 40px;
  line-height: 40px;
  border: none;
}

</style>
